import { Action, createReducer,on } from "@ngrx/store";
import {getProjectSessionData} from './project-session-actions'
import * as storage from '../storage';
import { AppState } from "./app.state";

export const initialState: AppState = {
    projectsessionreq: storage.getItem('projectsessionreq').projectsessionreq
}

const _projectSessionReducer = createReducer(initialState, on(getProjectSessionData, (state, result) => ({projectsessionreq: result.projectsessionreq})));


export function projectSessionReducer(state:AppState | undefined, action: Action) : any {
    return _projectSessionReducer(state,action);
}

export const getProjectSession = (state:AppState) => {
    return state.projectsessionreq;
}